var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Select from 'react-select';

var fontOptions = [{ value: 'Arial', label: 'Arial' }, { value: 'Calibri', label: 'Calibri' }, { value: 'Courier New', label: 'Courier New' }, { value: 'Droid', label: 'Droid' }, { value: 'Georgia', label: 'Georgia' }, { value: 'Helvetica', label: 'Helvetica' }, { value: 'Lato', label: 'Lato' }, { value: 'Montserrat', label: 'Montserrat' }, { value: 'Noto Sans', label: 'Noto Sans' }, { value: 'Open Sans', label: 'Open Sans' }, { value: 'PT Sans', label: 'PT Sans' }, { value: 'Raleway', label: 'Raleway' }, { value: 'Roboto', label: 'Roboto' }, { value: 'Source Sans Pro', label: 'Source Sans Pro' }, { value: 'Tahoma', label: 'Tahoma' }, { value: 'Times New Roman', label: 'Times New Roman' }, { value: 'Trebuchet MS', label: 'Trebuchet MS' }, { value: 'Ubuntu', label: 'Ubuntu' }];

var SelectFontFamily = function (_Component) {
  _inherits(SelectFontFamily, _Component);

  function SelectFontFamily(props) {
    _classCallCheck(this, SelectFontFamily);

    var _this = _possibleConstructorReturn(this, (SelectFontFamily.__proto__ || Object.getPrototypeOf(SelectFontFamily)).call(this, props));

    _this.handleFontChange = function (selectedOption) {
      // If selectedOption is null (i.e., the user cleared the selection),
      // set the default value back to "Please select or type"
      var newValue = selectedOption ? selectedOption.value : "";
      _this.props.onFontChange(newValue);
    };

    _this.state = {
      isClearable: true,
      isSearchable: true
    };
    return _this;
  }

  // handleFontChange = (selectedOption) => {
  //   // Pass the selected value to the callback function
  //   this.props.onFontChange(selectedOption.value || "");
  // };

  _createClass(SelectFontFamily, [{
    key: 'render',
    value: function render() {
      var defaultValue = this.props.defaultValue;


      var customStyles = {
        control: function control(base) {
          return Object.assign({}, base, {
            height: 56,
            minHeight: 56
          });
        }
      };

      var _state = this.state,
          isClearable = _state.isClearable,
          isSearchable = _state.isSearchable,
          isDisabled = _state.isDisabled,
          isLoading = _state.isLoading,
          isRtl = _state.isRtl;


      return React.createElement(
        'div',
        null,
        React.createElement(Select, {
          placeholder: React.createElement(
            'div',
            null,
            defaultValue || 'Please select or type'
          ),
          className: 'fontFamily',
          classNamePrefix: 'select',
          defaultValue: defaultValue || '',
          isDisabled: isDisabled,
          isLoading: isLoading,
          isClearable: isClearable,
          isRtl: isRtl,
          isSearchable: isSearchable,
          name: 'color',
          options: fontOptions,
          styles: customStyles,
          onChange: this.handleFontChange
        })
      );
    }
  }]);

  return SelectFontFamily;
}(Component);

export default SelectFontFamily;


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/components/SelectFontFamily.js